import axios from 'axios';
import router from '../router/index';

const API_URL = process.env.VUE_APP_BASE_URL;

const retrieveToken = () => JSON.parse(window.localStorage.getItem('token'));
const saveToken = (token) =>
  window.localStorage.setItem('token', JSON.stringify(token));
const clearToken = () => window.localStorage.removeItem('token');

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

export default function axiosInterceptors() {
  let isRefreshing = false;
  let failedQueue = [];

  const processQueue = (error, token = null) => {
    failedQueue.forEach((prom) => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });

    failedQueue = [];
  };

  axios.interceptors.request.use((config) => {
    const token = retrieveToken();
    token && (config.headers.Authorization = `Bearer ${token}`);
    return config;
  });

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      const originalRequest = error.config;
      const code = error.response.status;
      if (code === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          return new Promise(function (resolve, reject) {
            failedQueue.push({ resolve, reject });
          })
            .then((token) => {
              originalRequest.headers['Authorization'] = 'Bearer ' + token;
              return axios(originalRequest);
            })
            .catch((err) => {
              return Promise.reject(err);
            });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        return new Promise(function (resolve, reject) {
          axios
            .post('/refresh-token')
            .then((response) => {
              const newToken = response.data.access_token;
              axios.defaults.headers.common['Authorization'] =
                'Bearer ' + newToken;
              originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
              saveToken(newToken);
              processQueue(null, newToken);
              resolve(axios(originalRequest));
            })
            .catch((err) => {
              clearToken();
              router.push('/login');
              processQueue(err, null);
              reject(err);
            })
            .finally(() => {
              isRefreshing = false;
            });
        });
      }

      return Promise.reject(error);
    }
  );
}
